export const buildOrderPayload = (cart) => {
  return {
    items: cart.map((item) => ({
      productId: item.id || item.productId,
      quantity: item.qty || item.quantity || 1,
      complimentaryQuantity: item.complimentaryQuantity || 0,
      note: item.note || "",
      remarks: item.remarks || "",
      spicyLevel: item.spicyLevel || 1,
      isComplimentary: item.isComplimentary || false,

      // attributes:
      //   Array.isArray(item.attributes)
      //     ? item.attributes
      //     : Object.entries(item.attributes || {}).map(([title, value]) => ({
      //         title,
      //         value,
      //         spicyLevel: 1,
      //       })),

      // children: item.children || [],
    })),
  };
};
